export default __webpack_public_path__ + "static/media/10_The broken mirror.848769b1.jpg";